const initialState = {
  rolesFormsDetailsData: null,
};

/* ACTIONS */
const ROLES_FORMS_DETAILS_DATA = "app/roles/ROLES_FORMS_DETAILS_DATA";
const CLEAR_ROLES_FORMS_DATA = "app/roles/CLEAR_ROLES_FORMS_DATA";

type Action =
  | {
      type: typeof ROLES_FORMS_DETAILS_DATA;
      payload: any;
    }
  | {
      type: typeof CLEAR_ROLES_FORMS_DATA;
    };

/* REDUCER */
export default function reducer(state = initialState, action: any) {
  switch (action.type) {
    case ROLES_FORMS_DETAILS_DATA:
      return {
        ...state,
        rolesFormsDetailsData: action.payload,
      };

    case CLEAR_ROLES_FORMS_DATA:
      return {
        ...state,
        rolesFormsDetailsData: null,
      };

    default:
      return state;
  }
}

/* ACTION CREATORS */

export const setRolesFormsDetailsData = (payload: any): Action => ({
  type: ROLES_FORMS_DETAILS_DATA,
  payload: payload,
});

export const clearRolesFormsDetailsData = (): Action => ({
  type: CLEAR_ROLES_FORMS_DATA,
});

/* SELECTORS */
export const selectRolesFormsDetailsData = (app: any) =>
  app.roles.rolesFormsDetailsData;
